var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c("div", { staticClass: "materialFormLine" }, [_vm._v("广宣物料减库")]),
    _c(
      "div",
      { staticClass: "budgetBox" },
      [
        _c(
          "a-form-model",
          {
            ref: "materialForm",
            staticClass: "UniformCss",
            attrs: {
              inline: true,
              model: _vm.material,
              rules: _vm.rules,
              "label-width": "100px",
            },
          },
          [
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: "物料号", prop: "materialCode" } },
                      [
                        _c("a-input", {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.material.materialCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.material, "materialCode", $$v)
                            },
                            expression: "material.materialCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: "物料名称", prop: "materialName" } },
                      [
                        _c("a-input", {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.material.materialName,
                            callback: function ($$v) {
                              _vm.$set(_vm.material, "materialName", $$v)
                            },
                            expression: "material.materialName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: "现有库存", prop: "storage" } },
                      [
                        _c("a-input", {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.material.storage,
                            callback: function ($$v) {
                              _vm.$set(_vm.material, "storage", $$v)
                            },
                            expression: "material.storage",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: "减库数量", prop: "outNums" } },
                      [
                        _c("a-input", {
                          model: {
                            value: _vm.material.outNums,
                            callback: function ($$v) {
                              _vm.$set(_vm.material, "outNums", $$v)
                            },
                            expression: "material.outNums",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: "领用单位/人", prop: "drawMan" } },
                      [
                        _c("a-input", {
                          model: {
                            value: _vm.material.drawMan,
                            callback: function ($$v) {
                              _vm.$set(_vm.material, "drawMan", $$v)
                            },
                            expression: "material.drawMan",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 18 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: "领取用途", prop: "drawFor" } },
                      [
                        _c("a-input", {
                          model: {
                            value: _vm.material.drawFor,
                            callback: function ($$v) {
                              _vm.$set(_vm.material, "drawFor", $$v)
                            },
                            expression: "material.drawFor",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "btn-box" },
          [
            _c(
              "vxe-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.returnFun()
                  },
                },
              },
              [_vm._v("返回")]
            ),
            _c(
              "vxe-button",
              {
                attrs: { status: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.saveMaterialInfo("materialForm")
                  },
                },
              },
              [_vm._v("保存")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }